import { render, staticRenderFns } from "./orderWork.vue?vue&type=template&id=5f62ee01&scoped=true"
import script from "./orderWork.vue?vue&type=script&lang=js"
export * from "./orderWork.vue?vue&type=script&lang=js"
import style0 from "./orderWork.vue?vue&type=style&index=0&id=5f62ee01&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62ee01",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f62ee01')) {
      api.createRecord('5f62ee01', component.options)
    } else {
      api.reload('5f62ee01', component.options)
    }
    module.hot.accept("./orderWork.vue?vue&type=template&id=5f62ee01&scoped=true", function () {
      api.rerender('5f62ee01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/orderWork.vue"
export default component.exports